import React from 'react'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { Column, Row, Text } from 'Components/UI'

import { PROJECT } from 'Constants/Paths'

import { SECTORS_WE_ENGINEER_ITEMS } from './constants'
import { Container, StyledLink } from './styles'

type Props = PaddingProps

function SectorsWeEngineerForImpactSection({ ...rest }: Props) {
  return (
    <SectionWrapper asCard {...rest}>
      <Column alignCenter>
        <Text as="h2" center mb={5} medium title title40>
          Sectors We Build For
        </Text>

        <Text body body16 center maxWidth={640} mb={11} semiLight>
          The operational systems these businesses run on — and, increasingly,
          the AI running inside them.
        </Text>

        <Container
          gap={17}
          gridTemplateColumns={['1fr', '1fr', '1fr', '1fr', 'repeat(3, 1fr)']}
        >
          {SECTORS_WE_ENGINEER_ITEMS.map(item => (
            <Column alignCenter key={item.id}>
              {item.icon()}

              <Text as="h3" center mb={5} medium mt={7} title title28>
                {item.title}
              </Text>

              <Text body body16 center mb={7} preWrap semiLight>
                {item.description}
              </Text>

              <Row gap={6}>
                {item.projectLinks.map(projectLink => (
                  <StyledLink
                    href={PROJECT(projectLink.slug)}
                    key={projectLink.id}
                  >
                    {projectLink.name}
                  </StyledLink>
                ))}
              </Row>
            </Column>
          ))}
        </Container>
      </Column>
    </SectionWrapper>
  )
}

export default SectorsWeEngineerForImpactSection
